// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var React_Basic = require("../React.Basic/index.js");
var webview = React_Basic.element($foreign["_webview"]);
module.exports = {
    webview: webview,
    "_webview": $foreign["_webview"]
};
